module.exports = __webpack_public_path__ + "static/media/focus-devices.ac219a4d.jpg";